module.exports = __webpack_public_path__ + "static/img/icon_centrala_obudowa.e83beef.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon_centrala_obudowa.png
// module id = lM5E
// module chunks = 1